// extracted by mini-css-extract-plugin
module.exports = {"Page":"styles_Page__3COK7","asPaddingTop":"styles_asPaddingTop__30Qg-","content":"styles_content__MATre"};